import { Component, Inject, Input, OnDestroy } from '@angular/core';
import { GeneralService } from 'src/app/shared/services/general.service';
import { SignaturePadComponent } from 'src/app/shared/components/signature-pad/signature-pad.component';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { Subscription } from 'rxjs';
import { SignatureService } from '../../services/signature.service';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'signature-component',
  templateUrl: 'signature.component.html',
  styleUrls: ['signature.component.scss']
})
export class SignatureComponent implements OnDestroy {

  @Input() header = true;

  signatureFile : any = {};
  profile : any = {};

  hasSignature = false;

  filesSubscription: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    public gs: GeneralService,
    protected als: AppLoadingService,    
    protected signatureService : SignatureService,
  ) {

    this.filesSubscription = this.gs.filesChangeSubscription$.subscribe(async result => {
      
      if (!!result?.files?.length && result?.files?.at(0)?.original?.tags?.includes(308)) {
        await this.als.setLoaded(true, 'signature');
        this.setImage(result.files[0],result.files[0]?.file_id);
        await this.gs.doConfirmSignedIn(false);
        this.profile = await this.gs.getProfiledata();
        await this.als.setLoaded(false, 'signature');
      }

    });

    this.profile = this.gs.getProfiledata();
    if(this.profile?.signature_file_id && this.profile?.signature){
      this.setImage(this.profile?.signature, this.profile?.signature_file_id);
    }

  }

  ngOnDestroy() {
    this.filesSubscription?.unsubscribe();
  }

  setImage(file, fileId) {
    this.hasSignature = fileId;

    if(file){
      if(typeof file == 'string')
        file = this.gs.getFileLink(file,fileId)[0];

      this.signatureFile = this.gs.getFileName(file, 'original');
    } else {
      this.signatureFile = null;
    }
  }

  async deleteSignature(event){
    await this.signatureService.deleteSignature(this.hasSignature,this.profile.person_id).then(result => {
      this.setImage(false,false);
      this.gs.doConfirmSignedIn(false);      
    });
  }

  /** User Signature */

  async userSignature(data) {
    let modalId = 'SignaturePadComponent_'+Math.random();
    
    const dialogRef = this.dialog.open(SignaturePadComponent, 
    {   disableClose : true,
        id:modalId,
        data: {
          modalId : modalId,
          person_id : this.profile?.person_id,
          file_id : this.profile?.signature_file_id
        },        
    });
  }
}